<template>
  <div class="wrapper">
    <img class="bgImg" src="../../assets/images/downloadBg.jpg" alt="">
    <div class="button ios" @click="ios">
      <img src="../../assets/images/iosIcon.png" alt="">
      <span>iPhone版下载</span>
    </div>
    <div class="button android" @click="android">
      <img src="../../assets/images/androidIcon.png" alt="">
      <span>Android版下载</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data(){
        return{
        };
    },
    created() {

    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    methods:{
     is_weixin() {
      var ua = navigator.userAgent.toLowerCase();
      return (ua.match(/MicroMessenger/i) == "micromessenger");
    },
     ismobile(){
        var u = navigator.userAgent, app = navigator.appVersion;
        if(/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))){
          if(window.location.href.indexOf("?mobile")<0){
            try{
              if(/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)){
                return '0';
              }else{
                return '1';
              }
            }catch(e){}
          }
        }else if( u.indexOf('iPad') > -1){
          return '0';
        }else{
          return '1';
        }
      },
      android(){
       var isWeChat = this.is_weixin();
       if(isWeChat){
        this.$toast({
          message: '请在浏览器中打开此网页！',
          duration: 2000
        });
       }else if(this.ismobile() == '1'){
         var a = document.createElement('a');
         var url = 'https://ymrjimages.kjyoumi.com/document/Ymrj.V.1.0.2.apk';
         var filename = '有米日记.apk';
         a.href = url;
         a.download = filename;
         a.click();
       }
      },
      ios(){
        var isWeChat = this.is_weixin();
        if(isWeChat){
           this.$toast({
            message: '请在浏览器中打开此网页！',
            duration: 2000
          });
        }else if(this.ismobile() == '0'){
          window.location.href = 'https://apps.apple.com/us/app/%E6%9C%89%E7%B1%B3%E6%97%A5%E8%AE%B0/id1504030687?l=zh&ls=1'
        }
      }
    },
    mounted() {
       document.title = '下载';
    },
}
</script>

<style lang="less" scoped>
.wrapper {
    width: 100%;
    min-height: 100vh;
    background: #FD5656;
    position: relative;
}
.bgImg{
  width: 100%;
  height: 13.34rem;
}
.button{
  width: 5.1rem;
  height: .8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: .4rem;
  border:.02rem solid #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  img{
   width: .44rem;
   height: 0.54rem;
   margin-right: .42rem;
  }
  span{
    font-size: 0.4rem;
    color: #fff;
    font-weight: 500;
    line-height: .56rem;
  }
}
.ios{
 top: 8.34rem;
}
.android{
 top: 9.68rem;
}
</style>



// WEBPACK FOOTER //
// src/components/index/download.vue